/* Email capture popup.

   Rules it follows, in order of importance:
   - never on first paint; Google demotes pages that open an interstitial
     immediately for mobile search visitors
   - desktop waits for exit intent, mobile for time or scroll depth
   - once dismissed or subscribed, it stays gone for 60 days
   - never while a customer is logged in, or on cart / checkout
*/
(function () {
  var root = document.querySelector('[data-sg-popup]');
  if (!root) return;

  var KEY = 'sg-popup-seen';
  var DAYS = 60;
  var shown = false;
  // set by ?popup=test, so open() skips the 60-day memory as well
  var forced = false;

  function stored(k) {
    try { return window.localStorage.getItem(k); } catch (e) { return null; }
  }
  function store(k, v) {
    try { window.localStorage.setItem(k, v); } catch (e) { /* private mode */ }
  }

  function suppressed() {
    var t = stored(KEY);
    if (!t) return false;
    var age = Date.now() - parseInt(t, 10);
    return !(isNaN(age) || age > DAYS * 864e5);
  }

  function markSeen() { store(KEY, String(Date.now())); }

  function open() {
    if (shown || (!forced && suppressed())) return;
    shown = true;
    root.hidden = false;
    // next frame, so the transition actually runs
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    var input = root.querySelector('.sgpop__input');
    if (input && window.matchMedia('(min-width: 750px)').matches) input.focus();
    document.addEventListener('keydown', onKey);
  }

  function close() {
    if (!forced) markSeen();
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { root.hidden = true; }, 220);
  }

  function onKey(e) { if (e.key === 'Escape') close(); }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-sgpop-close]')) { e.preventDefault(); close(); }
  });

  // copy the code to the clipboard
  var copyBtn = root.querySelector('[data-sgpop-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = copyBtn.getAttribute('data-code');
      var hint = copyBtn.querySelector('.sgpop__copy-hint');
      var done = function () { if (hint) { hint.textContent = 'Copied'; } };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else {
        var ta = document.createElement('textarea');
        ta.value = code;
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (err) { /* ignore */ }
        document.body.removeChild(ta);
        done();
      }
    });
  }

  // Shopify reloads with ?customer_posted=true once the form is accepted
  if (location.search.indexOf('customer_posted=true') !== -1) {
    var form = root.querySelector('[data-sgpop-form]');
    var doneBox = root.querySelector('[data-sgpop-done]');
    if (form && doneBox) {
      form.hidden = true;
      doneBox.hidden = false;
      shown = false;
      open();
      markSeen();
    }
    return;
  }

  // ?popup=test opens it straight away and ignores the 60-day memory, so the
  // shop owner can always check it without clearing browser storage
  if (location.search.indexOf('popup=test') !== -1) {
    forced = true;
    setTimeout(open, 400);
    return;
  }

  if (suppressed()) return;
  // someone already signed in is already a customer
  if (document.body.classList.contains('customer-logged-in')) return;

  var delay = parseInt(root.getAttribute('data-delay'), 10);
  if (isNaN(delay)) delay = 20;

  var isDesktop = window.matchMedia('(min-width: 990px)').matches
    && !('ontouchstart' in window);

  if (isDesktop) {
    // exit intent: cursor leaving through the top of the viewport
    document.addEventListener('mouseout', function (e) {
      if (e.clientY <= 0 && !e.relatedTarget) open();
    });
    // a long, engaged visit still deserves the offer
    setTimeout(open, Math.max(delay, 45) * 1000);
  } else {
    setTimeout(open, delay * 1000);
    var fired = false;
    window.addEventListener('scroll', function () {
      if (fired) return;
      var h = document.documentElement;
      var pct = (h.scrollTop + window.innerHeight) / h.scrollHeight;
      if (pct > 0.5) { fired = true; open(); }
    }, { passive: true });
  }
})();
